import { render, staticRenderFns } from "./ReservationInfos.vue?vue&type=template&id=1922c2d2&scoped=true"
import script from "./ReservationInfos.vue?vue&type=script&lang=js"
export * from "./ReservationInfos.vue?vue&type=script&lang=js"
import style0 from "./ReservationInfos.vue?vue&type=style&index=0&id=1922c2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922c2d2",
  null
  
)

export default component.exports